/* src/app/components/payroll/invoices/staff/invoices-staff-list/invoice-staff-errorcode/invoice-staff-errorcode.component.css */
.custom-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=invoice-staff-errorcode.component-IORPLGFQ.css.map */
